import { ISupportRequestResponse } from '@/Interfaces/Support.interface';
import { SUPPORT_REQUEST_ENDPOINT } from '@/constants/endpoints';
import { SupportRequestPayload } from '@/types/support.types';
import axios from 'axios';

export const sendSupportRequest = async (params: SupportRequestPayload): Promise<ISupportRequestResponse> => {
  const resp = await axios.post(SUPPORT_REQUEST_ENDPOINT, { ...params });
  return resp.data;
};
